import { ReactNode } from 'react'
import { Box, SxProps } from '@mui/material'
import MUIDialogTitle from '@mui/material/DialogTitle'
import { theme } from 'src/providers/ThemeProvider'
import CloseButton from './CloseButton'

const styles = (): { root: SxProps; title: SxProps; closeBtn: SxProps } => ({
  root: {
    '&.MuiDialogTitle-bg': {
      color: 'white',
      backgroundColor: theme.palette.primary.main,
      padding: '50px 20px 50px 30px !important'
    }
  },
  title: {
    flex: '1 1 auto',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  closeBtn: {
    '& svg': {
      fontSize: '16px',
      color: 'white'
    }
  }
})

type Props = {
  children: ReactNode
  mode?: 'default' | 'withBg'
  onClose?: () => void
}

export default function DialogTitle(props: Props): JSX.Element {
  const { children, onClose, mode = 'default' } = props
  const className = mode === 'default' ? '' : 'MuiDialogTitle-bg'
  return (
    <MUIDialogTitle id="destinity-dialog" className={className} sx={styles().root}>
      <Box sx={styles().title}>{children}</Box>
      {onClose && <CloseButton styles={styles().closeBtn} onClose={onClose} />}
    </MUIDialogTitle>
  )
}
